const backButtonElem = document.querySelector('.btn--back');

if (backButtonElem) {
  attachEvent('.btn--back', 'click', () => {
    window.history.back();
  });
}
